import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { fetchIndustries } from "../api/industryApi";

const ServiceQuery = () => {
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(true);
  const carouselRef = useRef(null);

  // -----------------------------
  // Fetch industries
  // -----------------------------
  useEffect(() => {
    const loadIndustries = async () => {
      try {
        setLoading(true);
        const response = await fetchIndustries();

        const data =
          response?.data ||
          response?.industries ||
          (Array.isArray(response) ? response : []);

        setIndustries(data.filter(Boolean));
      } catch (error) {
        console.error("Error fetching industries:", error);
      } finally {
        setLoading(false);
      }
    };

    loadIndustries();
  }, []);

  // -----------------------------
  // Initialize Owl Carousel AFTER data render
  // -----------------------------
  useEffect(() => {
    if (!industries.length) return;
    if (!window.$ || !carouselRef.current) return;

    const $carousel = window.$(carouselRef.current);

    // Destroy existing carousel instance
    if ($carousel.hasClass("owl-loaded")) {
      $carousel.trigger("destroy.owl.carousel");
      $carousel.removeClass("owl-loaded");
      $carousel.find(".owl-stage-outer").children().unwrap();
    }

    // Init carousel
    $carousel.owlCarousel({
      items: 4,
      loop: true,
      margin: 0,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 4000,
      smartSpeed: 900,
      responsive: {
        0: { items: 1 },
        768: { items: 2 },
        1024: { items: 4 }
      }
    });

    // Apply data-bg-img manually
    $carousel.find("[data-bg-img]").each(function () {
      const bg = window.$(this).data("bg-img");
      if (bg) {
        window.$(this).css("background-image", `url(${bg})`);
      }
    });
  }, [industries]);

  if (loading) return null; // UI-safe (no layout shift)

  return (
    <div
      className="fn_cs_service_query"
      data-mobile="disable"
      data-column-count="4"
    >
      {/* Header */}
      <div className="top_bar">
        <div className="t_inner">
          <h3>Our Industries</h3>
          <span>
            Empowering Vidarbha’s Industrial Growth Through Innovation and
            Investment
          </span>
          <div className="owl_control">
            <div className="fn_prev"></div>
            <div className="fn_next"></div>
          </div>
        </div>
      </div>

      {/* Carousel */}
      <div className="service_part">
        <div className="owl-carousel" ref={carouselRef}>
          {industries?.map((industry) => (
            <div key={industry._id} className="item">
              <Link
                className="full_link"
                to={`/industrypage/${industry._id}`}
              ></Link>

              <div className="img_holder">
                <img src="img/thumb/480-700.jpg" alt="" />
                <div
                  className="abs_img"
                  data-bg-img={
                    industry.bannerImage ||
                    "img/service/single/default.jpg"
                  }
                ></div>
              </div>

              <div className="title">
                <h3>{industry.sectorName}</h3>
              </div>

              <div className="view_more">
                <Link className="more_link" to={`/industrypage/${industry._id}`}>
                  <span className="text">View More</span>
                  <span className="arrow">
                    <img className="fn__svg" src="svg/arrow-r.svg" alt="svg" />
                  </span>
                </Link>

              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceQuery;
